import useCurrency from '@/hooks/query/useCurrency';
import { IMoralisNFT } from '@/redux/loans/model';
import { trailingZeroCount } from '@/utils/formatter';

type NFTDataProps = {
  asset: {
    image_url: IMoralisNFT['normalized_metadata']['image'];
    rarity: IMoralisNFT['rarity_rank'];
    name: IMoralisNFT['name'];
    floorPriceInUsd: string | number | null;
  };
};

const useNFTData = ({ asset }: NFTDataProps) => {
  const { data } = useCurrency();
  const floor = Number(asset.floorPriceInUsd);
  const existFloor = floor ? floor / 100 : 0;
  const ethusd = data?.[0].quote.USD.price;
  const floorETHPrice = ethusd && existFloor ? existFloor / +ethusd : 0;
  const zeroCount = trailingZeroCount(floorETHPrice);
  const ETHPrice = zeroCount === 0 ? floorETHPrice.toFixed(2) : floorETHPrice.toFixed(zeroCount + 1);

  return { ETHPrice, existFloor };
};

export default useNFTData;
